<template>
  <EditCom
    title="创建订单"
    :target="createOrderTarget"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="closeFn"
  ></EditCom>

  <PayIntegral 
    v-if="orderTarget"
    :order="orderTarget"
    @close="orderTargetClose"
    @submit="paySubmitFn"
    @checkPay="payCheckPayFn"
  />
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import EditCom from '@/components/EditCom';
import PayIntegral from'@/components/PayModel/PayIntegral';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  'close',
]);

// 订单target
const orderTarget = ref(undefined),
      orderTargetClose = ()=>{
        orderTarget.value = undefined;
      },
      paySubmitFn = (order, loadFn)=>{
        createPayUrl({
          ...order,
          payAmount: order['amount'],
          mealType: '积分充值',
        }).then(res=>{
          if(res.data.code == 1004){
            window.open(res.data.data);
          }
          loadFn && loadFn();
        }).catch(err=>{
          loadFn && loadFn();
          console.log(err);
        });
      },
      payCheckPayFn = (order, loadFn)=>{
        checkingOrderAliPay(order).then(res=>{
          if(res.data.code == 1004){
            message(res.data.msg, 1);
            // orderTargetClose();
            closeFn()
          }
          loadFn && loadFn();
        }).catch(err=>{
          loadFn && loadFn();
          console.log(err);
        });
      }


// 创建订单
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn();
    }
  });
};
const submitFn = (item, button, loadFn, fn)=>{
  // console.log(item, button, loadFn, fn);
  createRechargeOrder(item).then(res=>{
    if(res.data.code == 1004){
      orderTarget.value = res.data.data;
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}

const closeFn = ()=>{
  emit('close');
}
const createOrderTarget = ref({
  integral: 0
}),
      buttonList = ref([
        { name: '取消', fun: closeFn, type: 'danger', },
        { name: '确定', fun: submit, type: 'primary', },
      ]),
      inputList = ref([
        { name: '积分', prop: 'integral', type: 'number',
          number: {
            min: 0
          }
        },
        { name: '优惠码', prop: 'discountNum', type: 'text' },
      ]),
      rules = reactive({
        price: [
          { required: true, message: '请输入积分', trigger: 'blur' },
        ],
      });

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>